import React from 'react';
import { Button } from 'rebass';
import { useHistory } from 'react-router-dom';
import NiceModal from 'components/NiceModal';
import useMutation from 'hooks/useMutation';
import { useToastHelper } from 'hooks/useToastHelper';
import services from 'services/services';
import { BrandingNameForm } from 'components/BrandingNameForm';

export const CreateBrandingModal = ({ isOpen, onClose }) => {
    const history = useHistory();
    const { addSuccessToast, addErrorToast } = useToastHelper();
    const { mutate: createBranding, isLoading } = useMutation({
        mutationFn: payload => services.createBranding(payload),
        /**
         * @param {import("services/services.js").Branding} branding
         */
        onSuccess: branding => {
            addSuccessToast('Branding created');
            history.push(`/settings/brandings/s/${branding.id}`);
            onClose && onClose();
        },
        onError: (_, errorMessage) => addErrorToast(errorMessage)
    });

    return (
        <NiceModal
            isOpen={isOpen}
            shouldCloseOnOverlayClick
            onRequestClose={onClose}
            style={{ content: { width: '510px' } }}
            title="Create a new branding"
        >
            <BrandingNameForm onCreate={createBranding} formId="create-branding" />
            <div className="modal-actions">
                <Button type="button" variant="secondary-gray" mr={3} onClick={onClose}>
                    Cancel
                </Button>
                <Button mr={0} form="create-branding" type="submit" variant="primary" disabled={isLoading}>
                    Create
                </Button>
            </div>
        </NiceModal>
    );
};
